<template>
  <button
    :type="htmlType"
    :class="disabled||myDisabled?['my-disabled-css',...classes]:classes"
    :style="styles"
    :disabled="disabled||myDisabled"
    :title="title"
    @click="handleClick"
  >
    <Icon prefixCls="ihlp-icon-r" class="ivu-load-loop" icon="circle-notch" v-if="loading"></Icon>
    <Icon
      :color="iconColor"
      :size="iconSize"
      :prefixCls="iconPrefixCls"
      :type="type"
      :icon="icon"
      v-if="icon && !loading"
    ></Icon>
    <span v-if="showSlot" ref="slot">
      <slot></slot>
    </span>
  </button>
</template>
<script>
import { oneOf } from "@/utils/assist";

const prefixCls = "ivu-btn";

export default {
  name: "ihlpButton",
  props: {
    type: {
      validator(value) {
        return oneOf(value, [
          "primary",
          "ghost",
          "dashed",
          "text",
          "info",
          "success",
          "warning",
          "error",
          "default"
        ]);
      }
    },
    shape: {
      validator(value) {
        return oneOf(value, ["circle", "circle-outline"]);
      }
    },
    size: {
      validator(value) {
        return oneOf(value, ["small", "large", "default"]);
      }
    },
    loading: Boolean,
    disabled: Boolean,
    isCopy: {
      type: Boolean,
      default: false
    },
    disabledTime: {
      type: [String, Number],
      default: 1000
    },
    notTimeout: Boolean,
    htmlType: {
      default: "button",
      validator(value) {
        return oneOf(value, ["button", "submit", "reset"]);
      }
    },
    iconPrefixCls: String,
    iconSize: String,
    iconColor: String,
    color: String,
    icon: String,
    title: String,
    long: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSlot: true,
      myDisabled: false
    };
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-${this.type}`]: !!this.type,
          [`${prefixCls}-long`]: this.long,
          [`${prefixCls}-${this.shape}`]: !!this.shape,
          [`${prefixCls}-${this.size}`]: !!this.size,
          [`${prefixCls}-loading`]: this.loading != null && this.loading,
          [`${prefixCls}-icon-only`]:
            !this.showSlot && (!!this.icon || this.loading),
          [`${prefixCls}-copy`]: this.isCopy 
        }
      ];
    },
    styles() {
      let style = {};
      if (this.color) {
        style.color = this.color;
      }
      return style;
    }
  },
  methods: {
    handleClick(event) {
      let self = this;
      this.$emit("click", event);
      if (!this.notTimeout) {
        //点击后禁用，延迟1秒后启用
        self.myDisabled = true;
        setTimeout(function() {
          self.myDisabled = false;
        }, this.disabledTime);
      }
    }
  },
  mounted() {
    this.showSlot = this.$slots.default !== undefined;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/btn/button.vue